export default __webpack_public_path__ + "static/media/dpi.5348bb9b.svg";